import { render, staticRenderFns } from "./OfficeHourDepartmentDatetimes.vue?vue&type=template&id=0b33c520&"
import script from "./OfficeHourDepartmentDatetimes.vue?vue&type=script&lang=js&"
export * from "./OfficeHourDepartmentDatetimes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports